// Couleurs du thème Orakle Weather
export const Colors = {
    write: '#FFF',
    black: '#0a1e2B',
    first: '#133EEA',
    second: '#fff9c0',
    third: '#e97569',
    fourth: '#21388B',
    others_1: '#285b80',
    others_2: '#B3B8BA',
};

// Thème Bootstrap 4 Dash
export const bs4DashTheme = {
    primary: '#21388B',
    secondary: '#e97569',
    success: '#A3BE8C',
    danger: '#dc3545',
    sidebarLightBg: '#3B4252',
    sidebarLightColor: '#E5E9F0',
    mainBg: '#2E3440',
    bodyColor: '#ECEFF4',
    cardBg: '#4C566A',
    white: '#E5E9F0',
    infoBoxBg: '#4C566A',
    dark: '#272c30',
    gray600: '#FFF',
};

// Autres constantes
export const APP_TITLE = 'Pricing tools';
export const APP_VERSION = '5.0.0';
export const ORAKLE_WEATHER_WEBSITE = 'https://orakleweather.com/';
export const ORAKLE_WEATHER_LOGO_URL = 'https://logo-orakle.s3.eu-west-3.amazonaws.com/logo_fond_bleu+(3).png';

export default Colors;

